import React from 'react';
import XiPageShell from '../components/xi/XiPageShell';
import PricingSection from '../components/PricingSection';

/**
 * Dedicated subscription destination.
 * `PricingSection` keeps its existing plan data, role tabs, PayPal/Stripe
 * checkout and payment modal untouched — only the surrounding chrome is new.
 */
export default function Plans() {
  return (
    <XiPageShell className="xi-plans">
      <PricingSection />
    </XiPageShell>
  );
}
